import React from 'react';
import {
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../../utils/formatters';

const BranchTotals = ({ analytics, analyticsLoading, user, isSuperAdmin, filters }) => {
    const { t } = useTranslation();

    // Only show if user has appropriate permissions
    const shouldShow = ((isSuperAdmin || user?.role === 'manager') && analytics && analytics.branchTotals) ||
        (user?.branch && analytics && analytics.branchTotals);

    if (!shouldShow || analyticsLoading) {
        return null;
    }

    return (
        <Box sx={{ my: 3 }}>
            <Typography variant="h6" gutterBottom>
                {t('dashboard.branchTotals')}
            </Typography>
            <TableContainer component={Paper} sx={{ mb: 2 }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('dashboard.branch')}</TableCell>
                            <TableCell>{t('appointments.paidAppointments')}</TableCell>
                            <TableCell>{t('dashboard.income')}</TableCell>
                            <TableCell>{t('dashboard.expenses')}</TableCell>
                            <TableCell>{t('dashboard.totalAppointmentCost')}</TableCell>
                            <TableCell>{t('dashboard.netProfit')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {analytics.branchTotals.map((row) => (
                            <TableRow key={row.branchId}>
                                <TableCell>{row.branchName || 'Unknown'}</TableCell>
                                <TableCell>{row.appointments}</TableCell>
                                <TableCell>{formatCurrency(row.income)}</TableCell>
                                <TableCell>{formatCurrency(row.totalExpenses)}</TableCell>
                                <TableCell>{formatCurrency(row.totalAppointmentCost)}</TableCell>
                                <TableCell >{formatCurrency(row.netProfit)}</TableCell>
                            </TableRow>
                        ))}
                        {/* Always show total row since branch filtering is removed */}
                        {(!filters.branch || filters.branch === '') && (
                            <TableRow sx={{ fontWeight: 'bold' }}>
                                <TableCell><b>{t('common.total')}</b></TableCell>
                                <TableCell><b>{analytics.grandTotal.appointments}</b></TableCell>
                                <TableCell><b>{formatCurrency(analytics.grandTotal.income)}</b></TableCell>
                                <TableCell><b>{formatCurrency(analytics.grandTotal.totalExpenses)}</b></TableCell>
                                <TableCell><b>{formatCurrency(analytics.grandTotal.totalAppointmentCost)}</b></TableCell>
                                <TableCell><b>{formatCurrency(analytics.grandTotal.netProfit)}</b></TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default BranchTotals;